(function() {
    'use strict';

    angular.module( APP_ID )
        .directive( 'feedbackPopup', [ '$analytics', '$cookies', '$timeout', '$location', 'LoggerFactory', 'TEXTS', 'CONFIG', FeedbackPopupDirective ] );

    /**
     * Survey/Feedback pop-up box.
     *
     * @attribute target-url ~ URL of the feedback form/site.
     * @attribute load-delay ~ How long after page load before displaying the
     * pop up.
     * @attribute title      ~ Popup's headline text.
     * @attribute content    ~ Popup's description text.
     * @attribute trackingCategoryId ~ Unique string to identify all captured
     * events within the Google Analytics' event tracking.
     * @attribute buttonOkLabel
     * @attribute buttonNoLabel
     * @attribute buttonNoTitle
     *
     *
     * @param {analytics} $analytics
     * @param {ng.ICookiesService} $cookies
     * @param {ng.ITimeoutService} $timeout
     * @param {ng.ILocationService} $location
     * @param {LoggerFactory} LoggerFactory
     * @param {Object} TEXTS
     * @param {Object} CONFIG
     *
     * @type {ng.IDirectiveCompileFn}
     */
    function FeedbackPopupDirective(
        $analytics,
        $cookies,
        $timeout,
        $location,
        LoggerFactory,
        TEXTS,
        CONFIG
    ){





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @type {Logger} */
        LoggerFactory.createLogger( 'FeedbackPopupDirective' );


        /** @constant */
        var POPUP_TIME_TO_SHOW_IN_MS = 120000, // seconds * 1000


        COOKIE = {
            ID:              'feedbackPopup',
            VERSION:         '1.1',
            EXPIRATION_DAYS: 28
            //secure: true   //If set to `true` the secure attribute of the cookie will be set and the cookie transmission will require a secure protocol (defaults to `false`).
        };


        /** @type {ng.IDirective} */
        var directiveConfig = {
            restrict: 'E',
            scope: {
                targetUrl:      '<',
                loadDelay:      '@',
                title:          '@',
                content:        '@',
                buttonOkLabel:  '@',
                buttonNoLabel:  '@',
                buttonNoTitle:  '@',
                trackingCategoryId:'@'
            },
            templateUrl:  'app/views/partials/widgets/feedback-popup.html',
            link: link
        };



        ////////////////////////////////////////////////////////////////////////

        return directiveConfig;

        ///////////////////////////////////////////////////////////////////////



        /**
         * @type {ng.IDirectiveLinkFn}
         *
         * @param {ng.IScope} $scope
         * @param {ng.IElement} $element
         */
        function link( $scope, element ) {





            /* ===== PRIVATE MEMBERS ======================================== */


            /** @constant */
            var PROPERTY_CONTENT_LOADED     = 'isContentReady',

            PROPERTY_HIDE_POPUP             = 'hidePopup',
            PROPERTY_HIDE_POPUP_IF_TARGET   = 'hidePopupWhenTargets';

            /** @type {DOMElement} */
            var feedbackContainer = element.children( '.popup-positioner' );
            //feedback              = feedbackContainer.children( '.popup'),
            //btnClose              = feedback.find( '.btn-close' ),
            //btnOk                 = feedback.find( '.btn.primary'),

            var loadDelayInMs   = 0,
            isTrackedInGA       = false,

            cookieObject        = {};

            cookieObject[ PROPERTY_HIDE_POPUP ]             = false;
            cookieObject[ PROPERTY_HIDE_POPUP_IF_TARGET ]   = {};







            /* ===== EXPOSE TO THE SCOPE ==================================== */


            // Members
            $scope._            = TEXTS.GENERIC.FEEDBACK_POPUP;
            $scope.isShown      = false;

            // Methods
            $scope.clickYes     = clickYes;
            $scope.clickNo      = clickNo;
            $scope.clickCancel  = clickCancel;





            /* ===== RUN ON INSTANTIATION =================================== */


            /** @constructor */
            (function init() {
                initProperties();
                setWatchers();
            })();


            /** @destructor */
            (function destroy(){
                element.on( '$destroy', function () {
                    if ( feedbackContainer ) {
                        feedbackContainer.remove();
                    }
                });
            })();





            /* ===== PUBLIC METHODS ========================================= */


            /**
             * Accept and go to the feedback.
             */
            function clickYes() {
                trackEvent( CONFIG.ANALYTICS.EVENT.POPUP_BUTTON_YES );
                hideFeedback( false );
            }


            /**
             * Cancel or hide popup.
             */
            function clickCancel() {
                trackEvent( CONFIG.ANALYTICS.EVENT.POPUP_BUTTON_CLOSE );
                hideFeedback( true );
            }


            /**
             * Refuse to participate and hide the popup.
             */
            function clickNo() {
                trackEvent( CONFIG.ANALYTICS.EVENT.POPUP_BUTTON_NO );
                hideFeedback( false );
            }





            /* ===== PRIVATE FUNCTIONS ====================================== */


            function initProperties() {
                loadDelayInMs   = $scope.loadDelay || POPUP_TIME_TO_SHOW_IN_MS;

                $scope.title    = $scope.title || $scope._.HEADING;
                $scope.content  = $scope.content || $scope._.CATCHER_TEXT;

                $scope.buttonOkLabel = $scope.buttonOkLabel || $scope._.BUTTON_OK_LABEL;

                $scope.buttonNoLabel = $scope.buttonNoLabel || null;
                $scope.buttonNoTitle = $scope.buttonNoTitle || $scope._.BUTTON_OK_LABEL;
                $scope.trackingCategoryId = $scope.trackingCategoryId || null;

                if ( $scope.trackingCategoryId ) isTrackedInGA = true;
            }


            function setWatchers() {
                var pageParentController = $scope.$parent.vm.hasOwnProperty( PROPERTY_CONTENT_LOADED ) ? $scope.$parent.vm : $scope.$parent.$parent.vm;

                $scope.$watch( function() { return pageParentController[ PROPERTY_CONTENT_LOADED ]; } , function( isContentLoaded ) {
                    if ( isContentLoaded ) initPopup();
                });
            }


            function trackEvent( eventId ) {
                if ( !isTrackedInGA ) return;

                $analytics.eventTrack( eventId, {
                    category:   $scope.trackingCategoryId,
                    label:      $location.absUrl()
                });
            }


            function retrievePopupCookie() {
                var clientsCookie = $cookies.getObject( COOKIE.ID );

                if ( clientsCookie ) {
                    if ( clientsCookie.hasOwnProperty( PROPERTY_HIDE_POPUP ) ) cookieObject[ PROPERTY_HIDE_POPUP ] = clientsCookie[ PROPERTY_HIDE_POPUP ];

                    if ( clientsCookie.hasOwnProperty( PROPERTY_HIDE_POPUP_IF_TARGET ) ) cookieObject[ PROPERTY_HIDE_POPUP_IF_TARGET ] = clientsCookie[ PROPERTY_HIDE_POPUP_IF_TARGET ];
                }
            }


            /**
             * Displays the pop-up if it was not suppressed.
             */
            function initPopup() {
                retrievePopupCookie();

                // Feedback should be shown
                if ( !cookieObject[ PROPERTY_HIDE_POPUP ] && !cookieObject[ PROPERTY_HIDE_POPUP_IF_TARGET ].hasOwnProperty( $scope.targetUrl ) ) {
                    feedbackContainer.detach();
                    angular.element( 'body' ).append( feedbackContainer );
                    $timeout( showFeedback, loadDelayInMs );
                }
            }


            function setPopupCookie( supressAll ) {
                var expireDate         = new Date();
                cookieObject[ PROPERTY_HIDE_POPUP ] = supressAll;

                if ( !supressAll ) {
                    // Supress specific targets only
                    cookieObject[ PROPERTY_HIDE_POPUP_IF_TARGET ][ $scope.targetUrl ] = true;
                }

                expireDate.setDate( expireDate.getDate() + COOKIE.EXPIRATION_DAYS );

                $cookies.putObject( COOKIE.ID, cookieObject, { expires: expireDate } );
            }


            function showFeedback() {
                $scope.isShown = true;
                feedbackContainer.fadeIn( 'slow', function() { });

                trackEvent( CONFIG.ANALYTICS.EVENT.POPUP_SHOWN );
            }


            function hideFeedback( hideForever ) {
                $scope.isShown = false;

                feedbackContainer.fadeOut( 'fast', function() { });
                setPopupCookie( hideForever );
            }


        }



    }
})();
